var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "通知设置",
        top: "7vh",
        width: "80%",
        visible: _vm.userNotifyConfigDialogVisible
      },
      on: {
        "update:visible": function($event) {
          _vm.userNotifyConfigDialogVisible = $event
        }
      }
    },
    [
      _c("UserNotifyConfigTable", { ref: "configTable_1" }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px", "margin-left": "10px" } },
        [
          _c("span", [_vm._v("如果账号没有邮箱，需要")]),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "javascript:alert('开发中,请联系管理员修改');" } },
            [_vm._v("去补充")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px", "margin-left": "10px" } },
        [
          _c("span", [_vm._v("如果账号没有绑定企业微信，需要")]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: "/ticket-vue/bind-work-weixin", target: "_blank" }
            },
            [_vm._v("去绑定")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22d7733e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d7733e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/UserNotifyConfigDialog.vue
// module id = 782
// module chunks = 75